import React from 'react';
import moment, { Moment } from 'moment';
import { Form, DatePicker } from 'antd';
import { WorksListItemExpirationType } from '@onboarding/services';

type Props = {
  expirationType: WorksListItemExpirationType;
};

export function ComplianceItemInputExpirationDate({ expirationType }: Props) {
  const disabledCompletedOn = (day: Moment) =>
    moment(day).isAfter(moment.now());
  const disabledExpiresOn = (day: Moment) => moment(day).isBefore(moment.now());

  function checkDocumentExpiration(_: unknown, selectedEndDate: Moment) {
    if (!selectedEndDate) {
      return Promise.resolve();
    }

    const today = moment().startOf('day');

    return selectedEndDate.isBefore(today)
      ? Promise.reject('The document is expired')
      : Promise.resolve();
  }

  return (
    <>
      {expirationType === 'COMPLETION_DATE' && (
        <Form.Item
          label="Completed On"
          name="completedOn"
          key="completedOn"
          rules={[
            { required: true, message: 'Please enter a completion date' },
          ]}
        >
          <DatePicker
            placeholder="mm/dd/yyyy"
            format="MM/DD/YYYY"
            size="large"
            className="sra-large-input"
            style={{ width: '100%' }}
            disabledDate={disabledCompletedOn}
          />
        </Form.Item>
      )}

      {expirationType === 'EXPIRATION_DATE' && (
        <Form.Item
          label="Expires On"
          name="expiresOn"
          key="expiresOn"
          rules={[
            { required: true, message: 'Please enter an expiration date' },
            { validator: checkDocumentExpiration },
          ]}
        >
          <DatePicker
            placeholder="mm/dd/yyyy"
            format="MM/DD/YYYY"
            size="large"
            className="sra-large-input"
            style={{ width: '100%' }}
            disabledDate={disabledExpiresOn}
          />
        </Form.Item>
      )}
    </>
  );
}
